<template>
  <div class="main">
    <div class="tablediv">
      <div class="total-title">
        <span class="top-title">企业列表</span>
        <div style="float:right;clear:both;">
          <span class="tablediv-span span-margin">
            企业总数：
            <span class="tablediv-span-count">{{totalCnt}}</span>
          </span>
          <span class="tablediv-span span-margin">
            待审核：
            <span class="tablediv-span-count">{{toAuditCnt}}</span>
          </span>
        </div>
      </div>
      <el-row class="row-style">
        <el-col :span="18" :offset="6">
          <el-input
            size="mini"
            style="width:344px"
            class="elmargin"
            placeholder="请输入企业名称，联系人，联系电话"
            v-model="corpinfo"
            clearable
          ></el-input>
          <el-select
            size="mini"
            style="width:105px"
            class="elmargin"
            placeholder="状态"
            v-model="useflg"
            clearable
          >
            <el-option
              v-for="item in useflgList"
              :key="item.code"
              :label="item.content"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-button type="primary" class="primarybtn" size="mini" @click="getInfo">筛选</el-button>
          <el-button size="mini" @click="reset">重置</el-button>
        </el-col>
      </el-row>

      <div class="tablepad">
        <el-table
          :data="corpList"
          style="width: 100%"
          empty-text="暂无企业"
          :height="tableHeight"
          header-row-class-name="tableHead"
          :header-cell-style="{'background-color':'#8D99AB'}"
          cell-class-name="tablebody"
        >
          <el-table-column prop="rowidx" label="序号" align="center" width="60"></el-table-column>
          <el-table-column prop="corp" label="企业名称"></el-table-column>
          <el-table-column prop="attn" label="联系人" width="100"></el-table-column>
          <el-table-column prop="ucode" label="联系电话" width="140"></el-table-column>
          <el-table-column prop="mail" label="电子邮箱"></el-table-column>
          <el-table-column prop="useflagname" label="状态" width="80"></el-table-column>
          <el-table-column label="操作" width="140">
            <template slot-scope="scope">
              <span class="iconfont iconybapi15" @click="showAudit(scope.row)"></span>
              <span
                v-show="scope.row.useflag == 1"
                class="iconfont iconybapi16"
                @click="showImport(scope.row.owner)"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="pageindex"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="corpCnt"
        ></el-pagination>
      </div>
    </div>
    <section v-show="auditDialogShow">
      <auditDialog
        transition="fade"
        transition-mode="out-in"
        :visible="auditDialogShow"
        :selCorp="selCorp"
        @close="onAuditClose"
        @query="getInfo"
      ></auditDialog>
    </section>

    <section v-show="importDialogShow">
      <importDialog
        transition="fade"
        transition-mode="out-in"
        :visible="importDialogShow"
        :selOwner="selOwner"
        @close="onImportClose"
        @query="getQuery"
      ></importDialog>
    </section>

    <section v-show="corpDetailDialogShow">
      <corpDetailDialog
        transition="fade"
        transition-mode="out-in"
        :visible="corpDetailDialogShow"
        :selCorp="selCorp"
        @close="onDetailClose"
        @query="getInfo"
      ></corpDetailDialog>
    </section>
  </div>
</template>

<script>
import util from "../components/util";
import auditDialog from "./auditDialog";
import importDialog from "./importDialog";
import corpDetailDialog from "./corpDetailDialog";
export default util.useCommon({
  data() {
    return {
      toAuditCnt: 0, //待审核企业
      totalCnt: 0, //企业总数
      auditDialogShow: false,
      importDialogShow: false,
      corpDetailDialogShow: false,
      corpList: [],
      pagesize: 10,
      pageindex: 1,
      corpCnt: 0,
      useflg: "",
      useflgList: [
        {
          code: "0",
          content: "待审核"
        },
        {
          code: "1",
          content: "已通过"
        }
      ],
      corpinfo: "", //企业名称，联系人，联系电话
      selCorp: {},
      selOwner: ""
    };
  },
  computed: {
    tableHeight: function() {
      return window.innerHeight - 320 + "px";
    }
  },
  components: {
    auditDialog: auditDialog,
    importDialog: importDialog,
    corpDetailDialog: corpDetailDialog
  },
  methods: {
    handleCurrentChange(val) {
      var v = this;
      v.pageindex = val;
      v.queryList();
    },
    getCorpInfo() {
      //待审核企业数、企业总数.
      var v = this;
      v.dopost("/corp/getCorpInfo", {}, function(result) {
        if ("0000" === result.state) {
          v.toAuditCnt = result.body.toAuditCnt;
          v.totalCnt = result.body.totalCnt;
        } else {
          var msg = [];
          for (var i = 0; i < result.body.length; i++) {
            msg.push(result.body[i].errmsg);
          }
          v.message("error", msg.join("<br/>"));
        }
        console.log(result);
      });
    },
    queryList() {
      //查询企业列表
      var v = this;
      v.dopost(
        "/corp/getCorpList",
        {
          pagesize: v.pagesize,
          pageindex: v.pageindex,
          corpinfo: v.corpinfo,
          useflg: v.useflg
        },
        function(result) {
          if ("0000" === result.state) {
            v.corpList = result.body.list;
            v.corpCnt = result.body.totalCnt;
          } else {
            var msg = [];
            for (var i = 0; i < result.body.length; i++) {
              msg.push(result.body[i].errmsg);
            }
            v.message("error", msg.join("<br/>"));
          }
          console.log(result);
        }
      );
    },
    query() {
      var v = this;
      v.pageindex = 1;
      v.queryList();
    },
    reset() {
      var v = this;
      v.useflg = "";
      v.corpinfo = "";
    },
    onAuditClose(result) {
      this.auditDialogShow = false;
    },
    onImportClose(result) {
      this.importDialogShow = false;
    },
    onDetailClose(result) {
      this.corpDetailDialogShow = false;
    },
    showAudit(corp) {
      var v = this;
      v.selCorp = corp;
      if (corp.useflag == 1) {
         v.corpDetailDialogShow = true;
      } else {
        v.auditDialogShow = true;
      }
    },
    showImport(owner) {
      this.selOwner = owner;
      this.importDialogShow = true;
    },
    getInfo() {
      //筛选
      var v = this;
      v.getCorpInfo();
      v.query();
    },
    getQuery(){
      //筛选
      var v = this;
      v.getCorpInfo();
      v.queryList();
    }
  },
  created: function() {},
  activated() {
    var v = this;
    v.getInfo();
  },
  mounted() {}
});
</script>
<style lang="scss" scoped>
.iconybapi15 {
  font-size: 20px;
  margin-right: 31px;
  color: #547cff;
  cursor: pointer;
}
.iconybapi16 {
  font-size: 20px;
  cursor: pointer;
  color: #547cff;
}
</style>